import {
  Box,
  Button,
  Flex,
  IconButton,
  useBreakpointValue,
} from "@chakra-ui/react";
import { FaRegPlusSquare } from "react-icons/fa";
import { FaRegCreditCard } from "react-icons/fa6";
import { IoBarChartSharp, IoPieChartSharp } from "react-icons/io5";
import { LuCalendarMinus } from "react-icons/lu";
import { TbCategoryPlus } from "react-icons/tb";
import { Link, useLocation } from "react-router-dom";
import { useTransactions } from "../../context/TransactionsContext";
import { currentMonthTransactionList } from "../../utils/helperFunctions";

export const Navbar = ({ supabaseClient }: any) => {
  const location = useLocation();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { transactions } = useTransactions();

  const currentMonthTranscations = currentMonthTransactionList(transactions);

  const navItems = [
    //@ts-ignore
    { to: "/", icon: <IoPieChartSharp />, label: "Übersicht" },

    {
      to: "/add-custom-categories",
      //@ts-ignore
      icon: <TbCategoryPlus />,
      label: "Kategorien Hinzufügen",
    },
    {
      to: "/add-amount",
      //@ts-ignore
      icon: <FaRegPlusSquare />,
      label: "Betrag Hinzufügen",
    },
    //@ts-ignore
    { to: "/fixed-costs", icon: <LuCalendarMinus />, label: "Fixkosten" },

    {
      to: "/budgets-and-goals",
      //@ts-ignore
      icon: <FaRegCreditCard />,
      label: "Limits & Sparziele",
    },

    ...(currentMonthTranscations.length > 0
      ? [
          {
            to: "/statistics",
            //@ts-ignore
            icon: <IoBarChartSharp />,
            label: "Statistiken",
          },
        ]
      : []),
  ];

  const signOut = async () => {
    const { error } = await supabaseClient.auth.signOut();
  };

  if (isMobile) {
    // 📱 Mobile Bottom Navigation
    return (
      <>
        <Flex
          top={0}
          left={0}
          right={0}
          bg="white"
          zIndex={1000}
          py={2}
          borderBottom="1px solid #ccc"
          justify="center"
          align="center"
        >
          <img
            src={require("../../assets/finecheck-dark-font.png")}
            alt="Finecheck Logo"
            width={"auto"}
            style={{
              height: "40px",
              objectFit: "contain",
            }}
          />
        </Flex>
        <Box
          position="fixed"
          bottom={0}
          left={0}
          right={0}
          bg="white"
          borderTop="1px solid #ccc"
          zIndex={1000}
          pt={4}
          pb={6}
        >
          <Flex justify="space-around">
            {navItems.map((item) => (
              <Link to={item.to} key={item.to}>
                <IconButton
                  aria-label={item.label}
                  variant={location.pathname === item.to ? "solid" : "ghost"}
                  colorScheme="teal"
                  size={"xl"}
                >
                  {item.icon}
                </IconButton>
              </Link>
            ))}
          </Flex>
        </Box>
      </>
    );
  }

  // 💻 Desktop Top Navigation
  return (
    <Box
      position="sticky"
      top={0}
      left={0}
      right={0}
      bg="white"
      borderBottom="1px solid #ccc"
      zIndex={1000}
      px={6}
      py={4}
    >
      <Flex gap={4} align="center" justify="space-between">
        <Box flex="1">
          <img
            src={require("../../assets/finecheck-dark-font.png")}
            alt="logo von FineCheck schwarzer schriftzug mit geldscheinen"
            width={"auto"}
            style={{ height: "35px", objectFit: "contain" }}
          />
        </Box>

        <Flex flex="2" justify="center" gap={4}>
          {navItems.map((item) => (
            <Link to={item.to} key={item.to}>
              <Button
                variant={location.pathname === item.to ? "solid" : "ghost"}
                colorScheme="teal"
              >
                {item.icon}
                {item.label}
              </Button>
            </Link>
          ))}
        </Flex>
        <Button onClick={signOut}>Ausloggen</Button>
        <Box flex="1" />
      </Flex>
    </Box>
  );
};
